<template>
  <div class="page-404">
    <h1 style="font-size: 100px; color: #ddd;">404</h1>
    <p style="font-size: 24px; color: #666; margin-bottom: 20px;">抱歉，你访问的页面不存在</p>
    <a-button type="primary" size="large" @click="$router.push('/')">
      返回首页
    </a-button>
  </div>
</template>

<script>
    export default {
        name: 'Page404'
    }
</script>

<style scoped>
    .page-404 {
        text-align: center;
        padding-top: 150px;
    }
</style>